import { useNavigationManager } from '@provider/navigation';
import { RetryButton } from '@utils/component-framework';
import { iArkStore } from '../state/store.js';
import { jsx } from 'react/jsx-runtime';

function IArkRetryButton(props) {
  const dispatch = iArkStore.useDispatch();
  const navigation = useNavigationManager();
  const onReset = async () => {
    dispatch(iArkStore.actions.resetEntry());
    navigation.push("/");
  };
  return /*#__PURE__*/jsx(RetryButton, {
    context: props.context,
    onClick: props.onClick,
    onReset: onReset
  });
}

export { IArkRetryButton };
//# sourceMappingURL=modal.retry.js.map
